import React, {
  useEffect,
  useState,
    useRef,
} from 'react';
import { Bell, BellOff, X, CheckCircle, AlertTriangle, UserX, FileText, Clock, ArrowLeft, Truck, Store, Bike, Users } from 'lucide-react';
import { io } from 'socket.io-client';
import { serverURL, getData  } from '../../../../services/Fetchnodeservices';



const socket = io(serverURL, {
  transports: ["polling", "websocket"],
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  autoConnect: true,
});


const ALL = {
  user: {
    label: 'Users',
    Icon: Users,
    bg: '#f3e8ff',
    color: '#6d28d9',
    items: [],
  },

  vendor: {
    label: 'Vendors',
    Icon: Truck,
    bg: '#fef9c3',
    color: '#854d0e',
    items: [],
  },

  rider: {
    label: 'Riders',
    Icon: Bike,
    bg: '#dcfce7',
    color: '#166534',
    items: [],
  },
};

// const socket = io(serverURL, {

//   transports: [
//     'websocket',
//     'polling'
//   ],

//   reconnection: true,

//   reconnectionAttempts: Infinity,

//   reconnectionDelay: 1000,

//   autoConnect: true,

// });

const playNotificationSound = () => {
  try {
    const audio = new Audio('/sounds/notification.mp3');

    audio.volume = 1;

    audio.play().catch(error => {
      console.log(
        '🔇 Notification sound blocked:',
        error.message
      );
    });
  } catch (error) {
    console.log(
      '❌ Notification sound error:',
      error
    );
  }
};

function NotifCard({ n, onDismiss }) {
  const Icon = n.Icon;
  
  return (
    <div style={{
      display: 'flex', 
      alignItems: 'flex-start', 
      gap: '10px',
      background: '#fff', 
      border: n.unread ? '1px solid #B5D4F4' : '1px solid #e5e7eb',
      borderLeft: n.unread ? '3px solid #378ADD' : '1px solid #e5e7eb',
      borderRadius: '8px', 
      padding: '10px 12px', 
      position: 'relative', 
      marginBottom: '6px',
      transition: 'all 0.2s ease',
      width: '100%',
      boxSizing: 'border-box',
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.06)';
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.boxShadow = 'none';
    }}
    >
      {n.unread && (
        <span style={{ position: 'absolute', top: '8px', right: '8px', width: '6px', height: '6px', borderRadius: '50%', background: '#378ADD' }} />
      )}
      <div style={{ 
        width: '32px', 
        height: '32px', 
        borderRadius: '8px', 
        background: n.ibg, 
        color: n.ic, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        flexShrink: 0 
      }}>
        <Icon size={14} />
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '2px' }}>
          <span style={{ fontSize: '11px', fontWeight: '600', color: '#111827' }}>{n.title}</span>
          <span style={{
            fontSize: '8px',
            color: n.unread ? '#378ADD' : '#6b7280',
            background: n.unread ? '#eff6ff' : '#f3f4f6',
            padding: '1px 6px',
            borderRadius: '4px',
            fontWeight: 500,
          }}>
            {n.type}
          </span>
        </div>
        <p style={{ fontSize: '10px', color: '#6b7280', margin: '0 0 4px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {n.msg}
        </p>
        <span style={{ fontSize: '9px', color: '#9ca3af', display: 'flex', alignItems: 'center', gap: '3px' }}>
          <Clock size={9} /> {n.time}
        </span>
      </div>
      <button 
        onClick={() => onDismiss(n.id)} 
        style={{ 
          background: 'none', 
          border: 'none', 
          cursor: 'pointer', 
          color: '#9ca3af', 
          padding: '2px',
          flexShrink: 0,
          borderRadius: '4px',
          transition: 'all 0.2s',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = '#f3f4f6';
          e.currentTarget.style.color = '#ef4444';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = 'transparent';
          e.currentTarget.style.color = '#9ca3af';
        }}
      >
        <X size={12} />
      </button>
    </div>
  );
}

export default function ShowNotification({
    popupMode = false
}) {

  const notificationAudioRef = useRef(null);
const audioUnlockedRef = useRef(false);

useEffect(() => {

  const audio =
    new Audio('/sounds/notification.mp3');

  audio.preload = 'auto';
  audio.volume = 1;

  notificationAudioRef.current = audio;

  const unlockAudio = async () => {

    if (audioUnlockedRef.current) {
      return;
    }

    try {

      audio.muted = true;

      await audio.play();

      audio.pause();
      audio.currentTime = 0;
      audio.muted = false;

      audioUnlockedRef.current = true;

      console.log(
        '🔊 ADMIN NOTIFICATION AUDIO UNLOCKED'
      );

    } catch (error) {

      console.log(
        '🔇 AUDIO UNLOCK ERROR:',
        error.message
      );

    }

  };

  document.addEventListener(
    'click',
    unlockAudio
  );

  document.addEventListener(
    'keydown',
    unlockAudio
  );

  return () => {

    document.removeEventListener(
      'click',
      unlockAudio
    );

    document.removeEventListener(
      'keydown',
      unlockAudio
    );

  };

}, []);


const playNotificationSound = async () => {

  try {

    const audio =
      notificationAudioRef.current;

    if (!audio) {

      console.log(
        '❌ NOTIFICATION AUDIO NOT READY'
      );

      return;
    }

    audio.pause();
    audio.currentTime = 0;
    audio.muted = false;

    await audio.play();

    console.log(
      '🔊 ADMIN NOTIFICATION SOUND PLAYED'
    );

  } catch (error) {

    console.log(
      '🔇 NOTIFICATION SOUND FAILED:',
      error.name,
      error.message
    );

  }

};
  // const [data, setData] = useState(ALL);
  const [data, setData] = useState(() => {

  try {

    const saved =
      localStorage.getItem('admin_notifications');

    if (!saved) return ALL;

    const parsed = JSON.parse(saved);

    return {

      user: {
        ...ALL.user,
        items: (parsed.user?.items || []).map(item => ({
          ...item,
          Icon: Users
        }))
      },

      vendor: {
        ...ALL.vendor,
        items: (parsed.vendor?.items || []).map(item => ({
          ...item,
          Icon: String(item.type || '')
            .toLowerCase()
            .includes('cancel')
              ? AlertTriangle
              : Store
        }))
      },

      rider: {
        ...ALL.rider,
        items: (parsed.rider?.items || []).map(item => ({
          ...item,
          Icon: Bike
        }))
      }

    };

  } catch (error) {

    console.log(
      '❌ Notification load error:',
      error
    );

    return ALL;
  }

});
  const [view, setView] = useState('main');

  useEffect(() => {

  try {

    const saveData = {

      user: {
        items: data.user.items.map(
          ({ Icon, ...item }) => item
        )
      },

      vendor: {
        items: data.vendor.items.map(
          ({ Icon, ...item }) => item
        )
      },

      rider: {
        items: data.rider.items.map(
          ({ Icon, ...item }) => item
        )
      }

    };

    localStorage.setItem(
      'admin_notifications',
      JSON.stringify(saveData)
    );

  } catch (error) {

    console.log(
      '❌ Notification save error:',
      error
    );

  }

}, [data]);


  
useEffect(() => {

  /*
   * ==========================================
   * SOCKET CONNECTED
   * ==========================================
   */

  const handleConnect = () => {

  console.log(
    '✅ ADMIN WEB SOCKET CONNECTED:',
    socket.id
  );

  socket.emit(
    'join-admin-panel',
    {
      email:
        localStorage.getItem('email') ||
        'web-admin'
    }
  );

};


  /*
   * ==========================================
   * 👤 NEW USER
   * ==========================================
   */

  const handleNewUser = data => {
console.log("Socket ID:", socket.id);
console.count("NEW USER EVENT");
console.log(data);
    console.log(
      '👤 WEB ADMIN - NEW USER:',
      data
    );

    addLiveNotification(data);  

  };


  /*
   * ==========================================
   * 🏪 NEW RESTAURANT
   * ==========================================
   */

  const handleNewRestaurant = data => {

    console.log(
      '🏪 WEB ADMIN - NEW RESTAURANT:',
      data
    );

    addLiveNotification(data);

  };


  /*
   * ==========================================
   * ✅ RESTAURANT VERIFIED
   * ==========================================
   */

  const handleRestaurantVerified = data => {

    console.log(
      '✅ WEB ADMIN - RESTAURANT VERIFIED:',
      data
    );

    addLiveNotification(data);

  };


  /*
   * ==========================================
   * 🛒 NEW ORDER
   * ==========================================
   */

  const handleNewOrder = data => {

    console.log(
      '🛒 WEB ADMIN - NEW ORDER:',
      data
    );

    addLiveNotification(data);

  };


  /*
   * ==========================================
   * ❌ RESTAURANT CANCELLED ORDER
   * ==========================================
   */

  const handleRestaurantCancellation = data => {

    console.log(
      '❌ WEB ADMIN - RESTAURANT CANCELLED ORDER:',
      data
    );

    addLiveNotification(data);

  };


  /*
   * ==========================================
   * 🛵 NEW RIDER
   * ==========================================
   */

  const handleNewRider = data => {

    console.log(
      '🛵 WEB ADMIN - NEW RIDER:',
      data
    );

    addLiveNotification(data);

  };


  /*
   * ==========================================
   * CONNECTION ERROR
   * ==========================================
   */

  const handleConnectError = error => {

    console.log(
      '❌ ADMIN WEB SOCKET ERROR:',
      error.message
    );

  };


  // ==========================================
  // REGISTER LISTENERS
  // ==========================================

  socket.on(
    'connect',
    handleConnect
  );

  socket.on(
    'connect_error',
    handleConnectError
  );

  socket.on(
    'new-user-notification',
    handleNewUser
  );

  socket.on(
    'new-restaurant-notification',
    handleNewRestaurant
  );

  socket.on(
    'restaurant-verified-notification',
    handleRestaurantVerified
  );

  socket.on(
    'new-order-notification',
    handleNewOrder
  );

  socket.on(
    'restaurant-order-cancelled-notification',
    handleRestaurantCancellation
  );

  socket.on(
    'new-rider-notification',
    handleNewRider
  );


  /*
   * Socket agar component mount hone se
   * pehle hi connected ho chuka ho
   */

  if (socket.connected) {

  console.log(
    '✅ ADMIN WEB SOCKET ALREADY CONNECTED:',
    socket.id
  );

  socket.emit(
    'join-admin-panel',
    {
      email:
        localStorage.getItem('email') ||
        'web-admin'
    }
  );

}

  // ==========================================
  // CLEANUP
  // ==========================================

  return () => {

    socket.off(
      'connect',
      handleConnect
    );

    socket.off(
      'connect_error',
      handleConnectError
    );

    socket.off(
      'new-user-notification',
      handleNewUser
    );

    socket.off(
      'new-restaurant-notification',
      handleNewRestaurant
    );

    socket.off(
      'restaurant-verified-notification',
      handleRestaurantVerified
    );

    socket.off(
      'new-order-notification',
      handleNewOrder
    );

    socket.off(
      'restaurant-order-cancelled-notification',
      handleRestaurantCancellation
    );

    socket.off(
      'new-rider-notification',
      handleNewRider
    );

  };

}, []);


const addLiveNotification = (notification) => {

  console.log(
    '🔔 ADDING LIVE NOTIFICATION:',
    notification
  );
    // playNotificationSound();


  const notificationType = String(
    notification?.type ||
    notification?.notificationType ||
    ''
  ).toLowerCase();

  let category = 'user';

  let Icon = CheckCircle;

  let ibg = '#dcfce7';

  let ic = '#166534';


  // ==========================================
  // RIDER NOTIFICATIONS
  // ==========================================

  if (
    notificationType.includes('rider') ||
    notificationType.includes('driver')
  ) {

    category = 'rider';

    Icon = Bike;

    ibg = '#dcfce7';

    ic = '#166534';

  }


  // ==========================================
  // RESTAURANT / ORDER NOTIFICATIONS
  // ==========================================

  else if (
    notificationType.includes('restaurant') ||
    notificationType.includes('vendor') ||
    notificationType.includes('order')
  ) {

    category = 'vendor';

    Icon = Store;

    ibg = '#fef9c3';

    ic = '#854d0e';


    // Cancellation notification
    if (
      notificationType.includes('cancel')
    ) {

      Icon = AlertTriangle;

      ibg = '#fee2e2';

      ic = '#991b1b';

    }

  }


  // ==========================================
  // USER NOTIFICATIONS
  // ==========================================

  else {

    category = 'user';

    Icon = Users;

    ibg = '#f3e8ff';

    ic = '#6d28d9';

  }


  // ==========================================
  // CREATE NOTIFICATION OBJECT
  // ==========================================

  const newNotification = {

    id:
      notification?.id ||
      `${Date.now()}-${Math.random()}`,

    unread: true,

    type:
      notification?.type ||
      'New',

    title:
      notification?.title ||
      'New Notification',

    msg:
      notification?.message ||
      notification?.msg ||
      'New activity received',

    time: 'Just now',

    Icon,

    ibg,

    ic

  };

window.dispatchEvent(
  new CustomEvent("admin-live-notification", {
    detail: newNotification,
  })
);
  // ==========================================
  // ADD TO CORRECT COLUMN
  // ==========================================

  setData(prev => ({

    ...prev,

    [category]: {

      ...prev[category],

      items: [

        newNotification,

        ...prev[category].items

      ]

    }

  }));

};

  const totalUnread = Object.values(data).flatMap(c => c.items).filter(n => n.unread).length;

  const dismiss = (cat, id) => {
    setData(prev => ({
      ...prev,
      [cat]: { ...prev[cat], items: prev[cat].items.filter(n => n.id !== id) }
    }));
  };

  const markAllRead = () => {
    setData(prev => {
      const next = {};
      Object.keys(prev).forEach(k => {
        next[k] = { ...prev[k], items: prev[k].items.map(n => ({ ...n, unread: false })) };
      });
      return next;
    });
  };

  // Get all items for preview
  const allItems = [
    ...data.user.items.map(n => ({ ...n, cat: 'user' })),
    ...data.vendor.items.map(n => ({ ...n, cat: 'vendor' })),
    ...data.rider.items.map(n => ({ ...n, cat: 'rider' })),
  ];
  const previewItems = allItems.slice(0, 3);

  // Group by category
  const userItems = data.user.items.map(n => ({ ...n, cat: 'user' }));
  const vendorItems = data.vendor.items.map(n => ({ ...n, cat: 'vendor' }));
  const riderItems = data.rider.items.map(n => ({ ...n, cat: 'rider' }));

  // Check if all sections are empty
  const allEmpty = userItems.length === 0 && vendorItems.length === 0 && riderItems.length === 0;

if (popupMode) {
    return null;
}

  return (
    <div style={{ 
      padding: '20px', 
      maxWidth: '1200px', 
      margin: '0 auto', 
      fontFamily: 'sans-serif',
      background: '#f8fafc',
      minHeight: '100vh',
      borderRadius: '12px',
    }}>

      {/* Header */}
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between', 
        padding: '14px 20px',
        background: '#fff',
        borderRadius: '12px',
        borderBottom: '1px solid #e5e7eb', 
        marginBottom: '20px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          {view === 'all' && (
            <button 
              onClick={() => setView('main')} 
              style={{ 
                background: 'none', 
                border: 'none', 
                cursor: 'pointer', 
                color: '#378ADD', 
                display: 'flex', 
                alignItems: 'center', 
                gap: '4px', 
                fontSize: '13px', 
                padding: '4px 10px',
                borderRadius: '6px',
                transition: 'all 0.2s',
              }}
              onMouseEnter={(e) => e.currentTarget.style.background = '#eff6ff'}
              onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
            >
              <ArrowLeft size={15} /> Back
            </button>
          )}
          {view === 'main' && <Bell size={18} color="#378ADD" />}
          <span style={{ fontSize: '15px', fontWeight: '600', color: '#111827' }}>
            {view === 'main' ? 'Notifications' : 'All Notifications'}
          </span>
          {totalUnread > 0 && (
            <span style={{ 
              background: '#378ADD', 
              color: '#fff', 
              fontSize: '10px', 
              fontWeight: '500', 
              padding: '2px 8px', 
              borderRadius: '10px' 
            }}>
              {totalUnread}
            </span>
          )}
        </div>
        <button 
          onClick={markAllRead} 
          style={{ 
            fontSize: '11px', 
            color: '#378ADD', 
            background: 'none', 
            border: 'none', 
            cursor: 'pointer',
            padding: '4px 10px',
            borderRadius: '6px',
            transition: 'all 0.2s',
          }}
          onMouseEnter={(e) => e.currentTarget.style.background = '#eff6ff'}
          onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
        >
          Mark all as read
        </button>
      </div>

      {/* Main View - 3 Column Layout */}
      {view === 'main' && (
        <>
          {allEmpty ? (
            <div style={{ 
              textAlign: 'center', 
              padding: '3rem 0', 
              color: '#9ca3af',
              background: '#fff',
              borderRadius: '12px',
              boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
            }}>
              <BellOff size={40} style={{ display: 'block', margin: '0 auto 10px' }} />
              <p style={{ fontSize: '14px' }}>Koi notification nahi</p>
            </div>
          ) : (
            // 3 Column Layout - Users | Vendors | Riders
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                background: '#fff',
                padding: '16px',
                borderRadius: '12px',
                boxSizing: 'border-box',
                boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                minHeight: '300px',
                gap: '16px',
              }}
            >
              {/* Users Column */}
              <div
                style={{
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '8px',
                  boxSizing: 'border-box',
                }}
              >
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  paddingBottom: '8px',
                  borderBottom: '2px solid #f3e8ff',
                }}>
                  <div style={{
                    width: '26px',
                    height: '26px',
                    borderRadius: '6px',
                    background: '#f3e8ff',
                    color: '#6d28d9',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                    <Users size={14} />
                  </div>
                  <span style={{ fontSize: '13px', fontWeight: '600', color: '#111827' }}>Users</span>
                  <span style={{ 
                    fontSize: '10px', 
                    color: '#6b7280', 
                    marginLeft: 'auto',
                    background: '#f3f4f6',
                    padding: '1px 6px',
                    borderRadius: '8px',
                  }}>
                    {userItems.length}
                  </span>
                </div>
                {userItems.length === 0 ? (
                  <div style={{ textAlign: 'center', padding: '20px 0', color: '#9ca3af', fontSize: '11px' }}>
                    No notifications
                  </div>
                ) : (
                  userItems.map(n => (
                    <NotifCard 
                      key={n.id} 
                      n={n} 
                      onDismiss={(id) => dismiss('user', id)} 
                    />
                  ))
                )}
              </div>

              {/* Vendors Column */}
              <div
                style={{
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '8px',
                  boxSizing: 'border-box',
                  borderLeft: '1px solid #e5e7eb',
                  borderRight: '1px solid #e5e7eb',
                  padding: '0 16px',
                }}
              >
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  paddingBottom: '8px',
                  borderBottom: '2px solid #fef9c3',
                }}>
                  <div style={{
                    width: '26px',
                    height: '26px',
                    borderRadius: '6px',
                    background: '#fef9c3',
                    color: '#854d0e',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                    <Truck size={14} />
                  </div>
                  <span style={{ fontSize: '13px', fontWeight: '600', color: '#111827' }}>Vendors</span>
                  <span style={{ 
                    fontSize: '10px', 
                    color: '#6b7280', 
                    marginLeft: 'auto',
                    background: '#f3f4f6',
                    padding: '1px 6px',
                    borderRadius: '8px',
                  }}>
                    {vendorItems.length}
                  </span>
                </div>
                {vendorItems.length === 0 ? (
                  <div style={{ textAlign: 'center', padding: '20px 0', color: '#9ca3af', fontSize: '11px' }}>
                    No notifications
                  </div>
                ) : (
                  vendorItems.map(n => (
                    <NotifCard 
                      key={n.id} 
                      n={n} 
                      onDismiss={(id) => dismiss('vendor', id)} 
                    />
                  ))
                )}
              </div>

              {/* Riders Column */}
              <div
                style={{
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '8px',
                  boxSizing: 'border-box',
                }}
              >
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  paddingBottom: '8px',
                  borderBottom: '2px solid #dcfce7',
                }}>
                  <div style={{
                    width: '26px',
                    height: '26px',
                    borderRadius: '6px',
                    background: '#dcfce7',
                    color: '#166534',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                    <Bike size={14} />
                  </div>
                  <span style={{ fontSize: '13px', fontWeight: '600', color: '#111827' }}>Riders</span>
                  <span style={{ 
                    fontSize: '10px', 
                    color: '#6b7280', 
                    marginLeft: 'auto',
                    background: '#f3f4f6',
                    padding: '1px 6px',
                    borderRadius: '8px',
                  }}>
                    {riderItems.length}
                  </span>
                </div>
                {riderItems.length === 0 ? (
                  <div style={{ textAlign: 'center', padding: '20px 0', color: '#9ca3af', fontSize: '11px' }}>
                    No notifications
                  </div>
                ) : (
                  riderItems.map(n => (
                    <NotifCard 
                      key={n.id} 
                      n={n} 
                      onDismiss={(id) => dismiss('rider', id)} 
                    />
                  ))
                )}
              </div>
            </div>
          )}
          
          <button 
            onClick={() => setView('all')} 
            style={{ 
              display: 'block', 
              width: '100%', 
              marginTop: '12px', 
              padding: '10px', 
              fontSize: '13px', 
              color: '#378ADD', 
              border: '1px solid #B5D4F4', 
              borderRadius: '8px', 
              background: '#fff',
              cursor: 'pointer',
              transition: 'all 0.2s',
              boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#eff6ff';
              e.currentTarget.style.borderColor = '#378ADD';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = '#fff';
              e.currentTarget.style.borderColor = '#B5D4F4';
            }}
          >
            See all notifications
          </button>
        </>
      )}

      {/* All View - 3 Column Layout (Same as Main View) */}
      {view === 'all' && (
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            background: '#fff',
            padding: '16px',
            borderRadius: '12px',
            boxSizing: 'border-box',
            boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
            minHeight: '300px',
            gap: '16px',
          }}
        >
          {/* Users Column */}
          <div
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              gap: '8px',
              boxSizing: 'border-box',
            }}
          >
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              paddingBottom: '8px',
              borderBottom: '2px solid #f3e8ff',
            }}>
              <div style={{
                width: '26px',
                height: '26px',
                borderRadius: '6px',
                background: '#f3e8ff',
                color: '#6d28d9',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
                <Users size={14} />
              </div>
              <span style={{ fontSize: '13px', fontWeight: '600', color: '#111827' }}>Users</span>
              <span style={{ 
                fontSize: '10px', 
                color: '#6b7280', 
                marginLeft: 'auto',
                background: '#f3f4f6',
                padding: '1px 6px',
                borderRadius: '8px',
              }}>
                {data.user.items.length}
              </span>
            </div>
            {data.user.items.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '20px 0', color: '#9ca3af', fontSize: '11px' }}>
                <CheckCircle size={22} style={{ display: 'block', margin: '0 auto 6px' }} /> Sab clear hai
              </div>
            ) : (
              data.user.items.map(n => <NotifCard key={n.id} n={n} onDismiss={(id) => dismiss('user', id)} />)
            )}
          </div>

          {/* Vendors Column */}
          <div
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              gap: '8px',
              boxSizing: 'border-box',
              borderLeft: '1px solid #e5e7eb',
              borderRight: '1px solid #e5e7eb',
              padding: '0 16px',
            }}
          >
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              paddingBottom: '8px',
              borderBottom: '2px solid #fef9c3',
            }}>
              <div style={{
                width: '26px',
                height: '26px',
                borderRadius: '6px',
                background: '#fef9c3',
                color: '#854d0e',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
                <Truck size={14} />
              </div>
              <span style={{ fontSize: '13px', fontWeight: '600', color: '#111827' }}>Vendors</span>
              <span style={{ 
                fontSize: '10px', 
                color: '#6b7280', 
                marginLeft: 'auto',
                background: '#f3f4f6',
                padding: '1px 6px',
                borderRadius: '8px',
              }}>
                {data.vendor.items.length}
              </span>
            </div>
            {data.vendor.items.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '20px 0', color: '#9ca3af', fontSize: '11px' }}>
                <CheckCircle size={22} style={{ display: 'block', margin: '0 auto 6px' }} /> Sab clear hai
              </div>
            ) : (
              data.vendor.items.map(n => <NotifCard key={n.id} n={n} onDismiss={(id) => dismiss('vendor', id)} />)
            )}
          </div>

          {/* Riders Column */}
          <div
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              gap: '8px',
              boxSizing: 'border-box',
            }}
          >
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              paddingBottom: '8px',
              borderBottom: '2px solid #dcfce7',
            }}>
              <div style={{
                width: '26px',
                height: '26px',
                borderRadius: '6px',
                background: '#dcfce7',
                color: '#166534',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
                <Bike size={14} />
              </div>
              <span style={{ fontSize: '13px', fontWeight: '600', color: '#111827' }}>Riders</span>
              <span style={{ 
                fontSize: '10px', 
                color: '#6b7280', 
                marginLeft: 'auto',
                background: '#f3f4f6',
                padding: '1px 6px',
                borderRadius: '8px',
              }}>
                {data.rider.items.length}
              </span>
            </div>
            {data.rider.items.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '20px 0', color: '#9ca3af', fontSize: '11px' }}>
                <CheckCircle size={22} style={{ display: 'block', margin: '0 auto 6px' }} /> Sab clear hai
              </div>
            ) : (
              data.rider.items.map(n => <NotifCard key={n.id} n={n} onDismiss={(id) => dismiss('rider', id)} />)
            )}
          </div>
        </div>
      )}
    </div>
  );
}